
import request from "@/utils/request";

// 公司详情
export function companyDetail(data) {
    return request({
        url: '/map/risun/compare/companyBasic',
        method: 'post',
        data: data
    })
}

// 公司详情(芳烃)
export function companyDetailFangTing(data) {
    return request({
        url: '/map/risun/compare/companyBasicSum',
        method: 'post',
        data: data
    })
}
// 区域供需汇总点击左侧区域(芳烃)
export function areaDetailFangTing(params) {
    return request({
        url: '/map/risun/compare/getOilBenzeneMapArea',
        method: 'get',
        params: params
    })
}
// 区域供需汇总苯流入流出(芳烃)
export function mapBen(params) {
    return request({
        url: '/map/risun/compare/getOilBenzeneMapSum',
        method: 'get',
        params: params
    })
}

// 焦炭地图
export function cokeMapDetail(data) {
    return request({
        url: '/map/risun/compare/getCokeMap',
        method: 'get',
        params: data
    })
}

// 钢铁地图
export function steelMapDetail(data) {
    return request({
        url: '/map/risun/compare/getSteelMap',
        method: 'get',
        params: data
    })
}

// 煤炭（焦煤）地图
export function coalMapDetail(data) {
    return request({
        url: '/map/risun/compare/getCoalMap',
        method: 'get',
        params: data
    })
}
// 煤炭（动力煤）地图
export function powerCoalMapDetail(data) {
    return request({
        url: '/map/risun/compare/getPowerCoalMap',
        method: 'get',
        params: data
    })
}

// 石油苯地图
export function oilBenzeneMapDetail(data) {
    return request({
        url: '/map/risun/compare/getOilBenzeneMap',
        method: 'get',
        params: data
    })
}

// 焦化苯地图
export function cokeBenzeneMapDetail(data) {
    return request({
        url: '/map/risun/compare/getCokeBenzeneMap',
        method: 'get',
        params: data
    })
}

// 苯乙烯地图
export function styreneMapDetail(data) {
    return request({
        url: '/map/risun/compare/getStyreneMap',
        method: 'get',
        params: data
    })
}

// 己内酰胺地图
export function caprolactamMapDetail(data) {
    return request({
        url: '/map/risun/compare/getCaprolactamMap',
        method: 'get',
        params: data
    })
}

// 己二酸地图
export function adipicMapDetail(data) {
    return request({
        url: '/map/risun/compare/getAdipicMap',
        method: 'get',
        params: data
    })
}

// 芳烃地图下拉框
export function methanolMapSelect(data) {
    return request({
        url: '/map/risun/compare/getDistinctVarieties',
        method: 'get',
        params: data
    })
}

// 甲醇地图
export function jiachunMapDetail(data) {
    return request({
        url: '/map/risun/compare/getAlcoholAmineMap',
        method: 'get',
        params: data
    })
}

// 甲醇地图下拉框
export function jiachunMapSelect(data) {
    return request({
        url: '/map/risun/compare/getAlcoholAmineVarieties',
        method: 'get',
        params: data
    })
}

// 碳材料地图
export function materialMapDetail(data) {
    return request({
        url: '/map/risun/compare/getCarbonMaterialMap',
        method: 'get',
        params: data
    })
}

// 碳材料地图下拉框
export function materialMapSelect(data) {
    return request({
        url: '/map/risun/compare/getCarbonMaterialVarieties',
        method: 'get',
        params: data
    })
}

